import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';

class PersonalCenterModalStore {
  @observable expandVideoUrl = '';
  @observable closeCallback = noop;

  //
  @observable data = null;

  constructor(options = {}) {
    Object.assign(this, options);
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    // this.clearStyle();
  };

  use() {
    useMount(() => { });
    useEffect(() => { }, []);
  }
}

export default PersonalCenterModalStore;
